/**
 * @architecture-header 1
 * @layer app
 * @domain parallel-development
 * @responsibility Mount Agent B's lane-owned top-level routes, and redirect the retired
 *   /teacher/organization-members path to the Settings Users tab (inherited ruling from
 *   SET-F05/F06/F09, executed by PR #257).
 * @state-owner Agent B feature modules
 * @allowed-imports React Router components and types (Navigate, RouteObject); Agent B module public APIs
 * @forbidden Agent A modules; workspace shell internals; direct API clients
 * @public-api agentBRoutes consumed by the shared router
 * @side-effects history-replacing redirect from /teacher/organization-members to
 *   /teacher/settings/users; the /join/:token entry delegates its effects (classroom join flow,
 *   session and navigation) to the classroom-join module; otherwise none
 * @tests Routes.test.tsx (redirect); app router tests and Agent B module Playwright flows
 */

import { Navigate, type RouteObject } from 'react-router-dom';
import { ClassroomJoinEntry } from '../../../modules/classroom-join';

export const agentBRoutes: RouteObject[] = [
  { path: '/join/:token', element: <ClassroomJoinEntry /> },
  {
    // Retired (inherited ruling from SET-F05/F06/F09): the Settings Users tab is the sole
    // membership-management entry point now. Redirect, not a hard 404, for any surviving
    // bookmark or link.
    path: '/teacher/organization-members',
    element: <Navigate replace to="/teacher/settings/users" />,
  },
];
